import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "./types";
import {
  fetchCustomerOrderAction,
  fetchFilteredOrganisationOrdersAction,
} from "./action";
import { OperationType } from "../../../enums/operation-type.enum";
import { OrderStatus } from "../../../enums/order-status.enum";
import { Platform } from "../../../enums/plaftorm.enum";

const initialState: InitialState = {
  loading: false,
  orderDetails: null,
  organisationOrdersData: {
    orders: [],
    total: 0,
  },
};

//slice here
const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //add builder for states
    builder.addCase(fetchCustomerOrderAction.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fetchCustomerOrderAction.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        orderDetails: action?.payload?.payload,
        error: false,
      };
    });
    builder.addCase(fetchCustomerOrderAction.rejected, (state) => {
      return {
        ...state,
        loading: true,
        orderDetails:null,
        error: true,
      };
    });

    // find filtered organisation orders
    builder.addCase(fetchFilteredOrganisationOrdersAction.pending, (state) => {
      return {
        ...state,
        loading: false,
      };
    });

    builder.addCase(
      fetchFilteredOrganisationOrdersAction.fulfilled,
      (state, action) => {
        const { payload } = action.payload;
        return {
          ...state,
          loading: false,
          organisationOrdersData: {
            orders: payload?.orders,
            total: payload?.total,
          },
        };
      }
    );

    builder.addCase(
      fetchFilteredOrganisationOrdersAction.rejected,
      (state, action) => {
        return {
          ...state,
          loading: false,
          organisationOrdersData: {
            orders: [],
            total: 0,
          },
        };
      }
    );
  },
});

export default orderSlice.reducer;
